import { capitalize } from "@/helpers/string.helpers"
import {
  INEQUALITY_SYMBOL,
  STRICT_EQUALITY_SYMBOL
} from "@/organisms/SmartSearch/const/symbol.constants"
import { getTokenTemplate } from "../helpers"
import { AbstractHandler } from "./token-handler"

import type { PropsHandler, Token, TokenTemplate } from "./token-handler.types"

export class TokenHandler extends AbstractHandler {
  public handle(token: TokenTemplate, props: PropsHandler): Token {
    const { str } = token
    const possibleQuery = str.startsWith('"')
    const [_id, delimiter, currentValue, ...needle] = possibleQuery
      ? [str]
      : str.split(/(:)/g)
    const id = delimiter ? _id.toLowerCase() : _id
    let value = currentValue

    value = value ? value + (needle || []).join("") : value

    const currentToken = getTokenTemplate(str, props)
    currentToken.id = id
    currentToken.delimiter = delimiter
    currentToken.value = value
    currentToken.inequality = id?.[0] === INEQUALITY_SYMBOL
    currentToken.strictEquality = id?.[0] === STRICT_EQUALITY_SYMBOL

    const { FilterService } = props

    const filter = FilterService.getFilterByLabel(id)

    if (delimiter) {
      const displayLabel = filter?.["displayLabel"]
      currentToken.label = displayLabel ?? capitalize(id)
    }

    const query = "query"

    if (id === query || possibleQuery) {
      currentToken.id = possibleQuery ? str : currentToken.value
      currentToken.str = possibleQuery ? `${query}:${str}` : currentToken.value
      currentToken.label = currentToken.value
      currentToken.delimiter = undefined
      currentToken.value = undefined
    } else if (id && delimiter && value && !filter) {
      const nextValue = `${id}${delimiter}${value}`
      currentToken.id = nextValue
      currentToken.str = nextValue
      currentToken.delimiter = undefined
      currentToken.value = undefined
    }

    currentToken.isTimeRange = filter?.type === "time-range"

    return super.handle(currentToken, props)
  }
}
